import React from 'react';
import { useReveal } from '../hooks/useReveal';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  as?: 'section' | 'header' | 'footer';
}
export function Section({
  children,
  className = '',
  as = 'section'
}: SectionProps) {
  const ref = useReveal<HTMLElement>();
  const Tag = as as React.ElementType;
  return <Tag ref={ref} className={`reveal ${className}`} data-id="element-105">
      {children}
    </Tag>;
}
export function GoldDivider({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`mx-auto flex items-center justify-center gap-3 py-2 ${className}`} aria-hidden="true" data-id="element-106">
      <span className="h-px w-16 bg-gradient-to-r from-transparent to-[#C9A24B]/70" data-id="element-107" />
      <span className="text-sm text-[#C9A24B]" data-id="element-108">✦</span>
      <span className="h-px w-16 bg-gradient-to-l from-transparent to-[#C9A24B]/70" data-id="element-109" />
    </div>;
}